import { Menu, PlayArrow } from '@mui/icons-material'
import React, { Component } from 'react'
import NavBarItem from './NavBarItem';
import FileNameDisplay from './FileNameDisplay';


export default class NavBar extends Component {
  render() {
    return (
      <div className='app-navbar'>
        <NavBarItem options={[{
          "onClick": this.props.callbacks.downloadProgram,
          "text": "Programm speichern"
        },
        {
          "onClick": this.props.callbacks.openProgram,
          "text": "Programm öffnen"
        }]}>
          <Menu className="app-navbar-icon" />
        </NavBarItem>
        <PlayArrow className="app-navbar-button" onClick={this.props.callbacks.runProgram} />
        <FileNameDisplay changeFilename={this.props.callbacks.changeFilename} filename={this.props.filename}/>
      </div>
    )
  }
}

